"use strict"

const originalForm = document.querySelector("product-form.product-form");
const stickyArea = document.getElementById("opt7_sticky_atc_section");
const duplicatedForm = originalForm.cloneNode(true);
const titleWrap = document.querySelector(".product__title");
const duplicatedTitle = titleWrap.cloneNode(true);

const isElementInViewport = (el) => {
    let rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

window.addEventListener("load", (event) => {
    const cartIcon = document.createElement("p");
    cartIcon.classList = "sticky-atc-shopping-cart-icon";
    cartIcon.style.width = "20px"
    cartIcon.style.height = "20px"
    cartIcon.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 576 512\"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d=\"M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z\"/></svg>";
    duplicatedForm.querySelector("button[type='submit']").prepend(cartIcon);
    duplicatedForm.querySelector(".buy-now").parentNode.removeChild(duplicatedForm.querySelector(".buy-now"));

    duplicatedForm.querySelector("button[type='submit']").addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        originalForm.querySelector("button[type='submit']").click();
        window.scrollTo({top: 0, behavior: 'smooth'});
    })

    duplicatedForm.querySelector(".product-quantity__minus").addEventListener("click", (e) => {
        setTimeout(() => {
            originalForm.querySelector(".qty-selector").value = duplicatedForm.querySelector(".qty-selector").value;
        }, 150)
    })

    duplicatedForm.querySelector(".product-quantity__plus").addEventListener("click", (e) => {
        setTimeout(() => {
            originalForm.querySelector(".qty-selector").value = duplicatedForm.querySelector(".qty-selector").value;
        }, 150)
    })

    originalForm.querySelector(".product-quantity__minus").addEventListener("click", (e) => {
        setTimeout(() => {
            duplicatedForm.querySelector(".qty-selector").value = originalForm.querySelector(".qty-selector").value;
        }, 150)
    })

    originalForm.querySelector(".product-quantity__plus").addEventListener("click", (e) => {
        setTimeout(() => {
            duplicatedForm.querySelector(".qty-selector").value = originalForm.querySelector(".qty-selector").value;
        }, 150)
    })

    duplicatedForm.querySelector(".qty-selector").addEventListener("input", (e) => {
        setTimeout(() => {
            originalForm.querySelector(".qty-selector").value = e.target.value;
        }, 150)
    })

    originalForm.querySelector(".qty-selector").addEventListener("input", (e) => {
        console.log(e)
        setTimeout(() => {
            duplicatedForm.querySelector(".qty-selector").value = e.target.value;
        }, 150)
    })

    stickyArea.appendChild(duplicatedTitle);
    stickyArea.appendChild(duplicatedForm);

    console.info(
        `%c Optimum7 Sticky ATC Initialized`,
        'color: #FFF; background:#ff9800;line-height:1.5;font-family:sans-serif;font-size:16px;font-weight:700;padding:6px 10px',
    );
});

window.addEventListener("scroll", () => {
    const atcButton = originalForm.querySelector("button[type='submit']")
    const isSticky = !isElementInViewport(atcButton);
    if (stickyArea) {
        if (isSticky) {
            stickyArea.classList.add("sticky");
        } else {
            stickyArea.classList.remove("sticky");
        }
    }
})